// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar.css */

.sidebar {
  width: 240px;
  flex-shrink: 0;
  background-color: var(--color-surface);
  padding: var(--space-6) 0 var(--space-5) 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: auto;
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--radius-xl);
  min-height: 0;
}

.sidebar-nav ul {
  list-style-type: none;
  padding: 0;
}

.sidebar-header {
  margin-bottom: var(--space-2);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 0 var(--space-5);
}

.sidebar-nav li {
  list-style-type: none;
  text-decoration: none;
  margin: 0 var(--space-3);
  height: 40px;
  align-items: center;
  display: flex;
  border-radius: var(--radius-sm);
  overflow: hidden;
}

.sidebar-link {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font: inherit;
  width: 100%;
  text-align: left;
  height: 100%;
  display: flex;
  align-items: center;
  transition: background-color 0.2s ease;
  padding-left: var(--space-3);
  border-radius: var(--radius-sm);
}

.sidebar-link:hover {
  background-color: var(--color-surface-muted);
}

.sidebar-item.active .sidebar-link {
  background-color: var(--color-light-green);
  font-weight: 600;
  color: var(--color-dark-green);
}

.sidebar-section {
  margin-bottom: var(--space-6);
}

.sidebar-section:last-child {
  margin-bottom: 0;
}

/* Responsive design */
@media (max-width: 1024px) {
  .sidebar {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;EACE,YAAY;EACZ,cAAc;EACd,sCAAsC;EACtC,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,4CAA4C;EAC5C,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* Sidebar.css */\n\n.sidebar {\n  width: 240px;\n  flex-shrink: 0;\n  background-color: var(--color-surface);\n  padding: var(--space-6) 0 var(--space-5) 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow-y: auto;\n  border: 1px solid var(--color-border-subtle);\n  border-radius: var(--radius-xl);\n  min-height: 0;\n}\n\n.sidebar-nav ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.sidebar-header {\n  margin-bottom: var(--space-2);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 0 var(--space-5);\n}\n\n.sidebar-nav li {\n  list-style-type: none;\n  text-decoration: none;\n  margin: 0 var(--space-3);\n  height: 40px;\n  align-items: center;\n  display: flex;\n  border-radius: var(--radius-sm);\n  overflow: hidden;\n}\n\n.sidebar-link {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  font: inherit;\n  width: 100%;\n  text-align: left;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  transition: background-color 0.2s ease;\n  padding-left: var(--space-3);\n  border-radius: var(--radius-sm);\n}\n\n.sidebar-link:hover {\n  background-color: var(--color-surface-muted);\n}\n\n.sidebar-item.active .sidebar-link {\n  background-color: var(--color-light-green);\n  font-weight: 600;\n  color: var(--color-dark-green);\n}\n\n.sidebar-section {\n  margin-bottom: var(--space-6);\n}\n\n.sidebar-section:last-child {\n  margin-bottom: 0;\n}\n\n/* Responsive design */\n@media (max-width: 1024px) {\n  .sidebar {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
